// pagPlayRegistry.js
'use strict';

const resolverRegistry = new Map();

/**
 * Register a resolver for a PAG play signal keyed by notice ID.
 * @param {object} params
 * @param {string} params.noticeId - The notice ID to register.
 * @param {Function} params.resolver - Called when PAG starts playing.
 * @example
 * registerPagPlayResolver({ noticeId: 'notice-1', resolver: () => null });
 */
const registerPagPlayResolver = ({ noticeId, resolver } = {}) => {
  resolverRegistry.set(noticeId, resolver);
};

/**
 * Remove a registered resolver without calling it (e.g. on timeout cleanup).
 * @param {object} params
 * @param {string} params.noticeId - The notice ID to unregister.
 * @example
 * unregisterPagPlayResolver({ noticeId: 'notice-1' });
 */
const unregisterPagPlayResolver = ({ noticeId } = {}) => {
  resolverRegistry.delete(noticeId);
};

/**
 * Signal that PAG has started playing for the given notice ID.
 * Calls and removes the registered resolver.
 * @param {object} params
 * @param {string} params.noticeId - The notice ID whose PAG started playing.
 * @example
 * resolvePagPlay({ noticeId: 'notice-1' });
 */
const resolvePagPlay = ({ noticeId } = {}) => {
  const resolver = resolverRegistry.get(noticeId);
  if (resolver) {
    resolver();
    resolverRegistry.delete(noticeId);
  }
};

export { registerPagPlayResolver, unregisterPagPlayResolver, resolvePagPlay };
